/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Footer_Badges_Invalid_CodeInputs */

const en_admin_footer_badges_invalid_code = /** @type {(inputs: Admin_Footer_Badges_Invalid_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not read this badge. Use an HTTPS link with an image or text. Scripts, inline SVG and event handlers are not supported.`)
};

/**
* | output |
* | --- |
* | "Could not read this badge. Use an HTTPS link with an image or text. Scripts, inline SVG and event handlers are not supported." |
*
* @param {Admin_Footer_Badges_Invalid_CodeInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_footer_badges_invalid_code = /** @type {((inputs?: Admin_Footer_Badges_Invalid_CodeInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Footer_Badges_Invalid_CodeInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_footer_badges_invalid_code(inputs)
});
export { admin_footer_badges_invalid_code as "admin.footer_badges.invalid_code" }